import React from 'react';
import * as Routes from '@/modules/routes';
import Modal, { Footer, useModalManager } from '@/components/common/Modal';
import cn from '@/utils/cn';
import Icon from '@/components/ui/Icon';

interface ProgramUsesProps {
  currentProgram: { title: string, id: number };
  numUses: number;
  programs: { title: string, id: number }[];
  title: string;
}

const ProgramUses = ({ currentProgram, numUses, programs, title }: ProgramUsesProps) => {
  const modalManager = useModalManager();

  return (
    <>
      <button
        className={cn(
          'tw-flex tw-items-center tw-h-5 tw-text-tci-purple tw-text-sm tw-font-semibold',
          'btn btn--sm tw-bg-light-saffron tw-border tw-border-saffron',
        )}
        type="button"
        onClick={modalManager.open}
      >
        <Icon icon="Venn" />
        <span className="tw-ml-1">{numUses}</span>
      </button>

      {modalManager.isOpen && (
        <Modal
          closeable
          closeModal={modalManager.close}
          headerText="Shared Programs"
          {...modalManager}
        >
          <div>
            <p className="tw-mb-8"><i>{title}</i> is used in {numUses} programs.</p>
            <p key={currentProgram.id} className="tw-mb-2">{currentProgram.title}</p>

            {programs.map(program => (
              <div key={program.id} className="tw-my-2">
                <a href={Routes.admin_program_lessons_path(program.id)} target="_blank">
                  {program.title}
                  <i className="tw-ml-2 fa fa-external-link" />
                </a>
              </div>
            ))}
          </div>
          <Footer
            primaryButtonCallback={modalManager.close}
            primaryButtonSubmit={false}
            primaryButtonText="Close"
          />
        </Modal>
      )}
    </>
  );
};

export default ProgramUses;
